import {call, put} from 'redux-saga/effects';
import {getBaseUrl} from '../../../core/utility/filter.utility';

import axios from 'axios';
import * as lexExamActionType from '../actionsType/lexExam.actionType';
import * as lexDetailActionType from '../actionsType/lexCntDetail.actionType';
import * as lexParentDetailActionType from '../actionsType/lexDetail.actionType';

function getLexCntDetail(reqObj) {
    return axios({
        method: 'post',
        url: `${getBaseUrl()}/rest/lp/expandContentDetails`,
        data: reqObj
    });
}

function requestCertVoucher(reqObj) {
    return axios({
        method: 'post',
        url: `${getBaseUrl()}/rest/lp/requestCertVoucher`,
        data: reqObj
    });
}

function initKryPrerequisite(reqObj) {
    return axios({
        method: 'post',
        url: `${getBaseUrl()}/rest/lp/initKryPrerequisite`,
        data: reqObj
    });
}

function downloadCert(reqObj) {
    return axios({
        method: 'post',
        url: `${getBaseUrl()}/rest/cert/downloadCert`,
        data: reqObj,
        responseType: 'arraybuffer'
    });
}

// function getLexCntDetail(reqObj) {
//     return axios({
//         method: 'get',
//         url: 'http://localhost:4000/lcoArr',
//         data: reqObj
//     });
// }

export function* fetchLexCntDetailSaga(request) {
    try {
        const response = yield call(getLexCntDetail, request.payload);
        const content = response.data.lcoArr;
        yield put({
            type: lexDetailActionType.FETCHING_LEX_DETAIL_SUCCESS,
            payload: content
        });
        yield put({
            type: lexDetailActionType.FETCHING_LEX_DETAIL,
            payload: false
        });
        yield put({
            type: lexDetailActionType.SET_IS_BLOCK,
            payload: request.payload.isBlock
        });
    } catch (error) {
        yield put({
            type: lexDetailActionType.FETCHING_LEX_DETAIL_ERROR,
            payload:
                'There has been some issue with 3DS Learning Space. Please try after sometime.'
        });
    }
}

export function* requestCertVoucherSaga(request) {
    try {
        const result = yield call(requestCertVoucher, request.payload);
        // console.log(result);
        const resArray = result.data.split(' | ');
        const flag = resArray[0];
        const msg = resArray[1];
        if (flag.trim() === 'success') {
            yield put({
                type: lexParentDetailActionType.FETCH_LEX_DATA,
                payload: request.payload
            });
        } else {
            yield put({
                type: lexDetailActionType.REQUEST_VOUCHER_ERROR,
                payload: {msg}
            });
        }
        // yield put({
        //     type: lexDetailActionType.REQUEST_VOUCHER_ERROR,
        //     payload: {msg: 'Failed to proceed the request'}
        // });
    } catch (error) {
        console.log(error);
    }
}

export function* initKryPreqstSaga(request) {
    try {
        const result = yield call(initKryPrerequisite, request.payload);
        // console.log(result);
        if (result && result.data) {
            yield put({
                type: lexExamActionType.INIT_KRY_PREREQUISITE_SUCCESS,
                payload: {
                    backendStatus:
                        lexExamActionType.INIT_KRY_PREREQUISITE_SUCCESS,
                    initUrl: result.data.initUrl,
                    regId: result.data.regCode
                }
            });
        } else {
            yield put({
                type: lexExamActionType.INIT_KRY_PREREQUISITE_FAILED,
                payload: {
                    backendStatus:
                        lexExamActionType.INIT_KRY_PREREQUISITE_FAILED,
                    backendMsg: result.statusText
                }
            });
        }
    } catch (error) {
        yield put({
            type: lexExamActionType.INIT_KRY_PREREQUISITE_FAILED,
            payload: {
                backendStatus: lexExamActionType.INIT_KRY_PREREQUISITE_FAILED,
                backendMsg: error.response
                    ? error.response.statusText
                    : error.message
            }
        });
    }
}

export function* downloadCertSaga(request) {
    try {
        // const {regId, code, contentTitle, learnerId} = request.payload;
        // const result = yield call(downloadCert, {regId, code});
        const {contentTitle, learnerId, id} = request.payload;
        const result = yield call(downloadCert, {id});
        // console.log(result);
        if (result && result.data) {
            yield put({
                type: lexExamActionType.LEX_EXAM_DOWNLOAD_CERT_SUCCESS,
                payload: {
                    backendStatus:
                        lexExamActionType.LEX_EXAM_DOWNLOAD_CERT_SUCCESS
                }
            });
            const pdfBlob = new Blob([result.data], {type: 'application/pdf'});
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(pdfBlob);
            link.download = `${learnerId}_${contentTitle}.pdf`;
            link.click();
            window.URL.revokeObjectURL(pdfBlob);
        } else {
            yield put({
                type: lexExamActionType.INIT_KRY_PREREQUISITE_FAILED,
                payload: {
                    backendStatus:
                        lexExamActionType.INIT_KRY_PREREQUISITE_FAILED,
                    backendMsg: result.statusText
                }
            });
        }
    } catch (error) {
        yield put({
            type: lexExamActionType.LEX_EXAM_DOWNLOAD_CERT_FAILED,
            payload: {
                backendStatus: lexExamActionType.LEX_EXAM_DOWNLOAD_CERT_FAILED,
                backendMsg: error.response
                    ? error.response.statusText
                    : error.message
            }
        });
    }
}
